import { useHistory } from "react-router-dom";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { message, Pagination, Row } from "antd";
import {
  AppstoreOutlined,
  HistoryOutlined,
  EditOutlined,
} from "@ant-design/icons";
import Button from "@components/Button";
import Table from "@components/Table";
import { getColumns } from "./config";
import { paths, permissions } from "@router";
import { useFetchOffersQuery, useReviseOfferMutation } from "@services";
import { useTypedSelector } from "@hooks";
import { handleStage, resetOffers } from "@store/offers";
import { Stage } from "@types";
import { checkPermission } from "@/utils";
import CustomButton from "@/components/customButton";
import { MdOutlineFileUpload } from "react-icons/md";
import SearchBox from "@/components/searchInput";
import CustomTabs from "@/components/customTabs";
import EditDialog from "./EditDialog";
import customErrorMessage from "@/components/CustomErrorMessage";
import "./index.less";

const Offers = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  // khurram
  const [selectedOffer, setSelectedOffer] = useState<{
    id: number;
    stage: Stage;
  } | null>(null);

  const [
    reviseOffer,
    {
      isLoading: isLoadingReviseOffer,
      isError: isErrorReviseOffer,
      isSuccess: isSuccessReviseOffer,
      error: errorReviseOffer,
    },
  ] = useReviseOfferMutation();
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [pageSize, setPageSize] = useState(10);

  const showModal = () => {
    setOpen(true);
  };

  const handleCancel = () => {
    setOpen(false);
  };
  const [page, setPage] = useState(1);
  const [searchInput, setSearchInput] = useState("");
  const [size, setSize] = useState("small");
  const [currentTab, setCurrentTab] = useState("1");

  const { company } = useTypedSelector(state => state.auth?.user!);
  const { id: company_id } = company!;
  const { data: offersData, isFetching: isLoading } = useFetchOffersQuery({
    company_id,
    page,
    page_size: pageSize,
    status:
      currentTab === "3"
        ? "DRAFTED"
        : currentTab === "1"
        ? "PLACED"
        : "ACCEPTED&statuses=REJECTED&statuses=EDITED",
  });
  const { data: offers, pagination } = offersData || {};

  const handleRowClick = (id: number, stage: Stage) => {
    dispatch(handleStage(stage));
    const step = Number(currentTab);
    // history.push(`/client/offers/offer/${id}`);
    // sessionStorage.setItem('state', JSON.stringify(step === 1 || step === 2 ? true : false,));
    history.push({
      pathname: `/client/offers/offer/${id}?step=${step}`,
      state: step === 1 || step === 2 ? true : false,
    });
  };
  // const handleEditClick = async (id: number, stage: Stage) => {
  //   dispatch(handleStage(stage));
  //   const response = await reviseOffer({
  //     company_id,
  //     id,
  //     body: {},

  //   }).unwrap();
  //   message.success(`Offer Edit success`);
  //   history.push(`/client/offers/offer/${response?.data?.id}?mode=revise`);
  //   showModal()
  // };
  const handleEditClick = async (id: number, stage: Stage) => {
    try {
      dispatch(handleStage(stage));
      const response = await reviseOffer({
        company_id,
        id,
        body: {},
      }).unwrap();

      message.success(`Offer Edit success`);
      history.push(`/client/offers/offer/${response?.data?.id}?mode=revise`);
      setOpen(false); // close dialog after success
    } catch (err) {
      customErrorMessage("Failed to edit offer");
    }
  };

  const showEditDialog = (id: number, stage: Stage) => {
    setSelectedOffer({ id, stage });
    setOpen(true);
  };

  // const columns = getColumns({ handleRowClick, currentTab, handleEditClick });
  const columns = getColumns({
    handleRowClick,
    currentTab,
    handleEditClick: showEditDialog, // 👈 notice we pass showEditDialog, not handleEditClick
  });
  const handlePageSizeChange = (current: number, pageSize: number) => {
    // onChangePage?.(1);
    setPageSize?.(pageSize);
  };

  return (
    <div>
      <div className="jobCreationBar bg-white px-4 py-6 rounded-lg flex justify-between items-center">
        <div className="title text-themeBlue font-medium text-3xl">
          {currentTab === "3"
            ? "Drafts"
            : currentTab === "1"
            ? "Offers"
            : "Past Offers"}
        </div>
        <div className="flex flex-row justify-between">
          {currentTab === "1" && checkPermission(permissions.CREATE_OFFER) ? (
            <CustomButton
              onClick={() => {
                dispatch(resetOffers());
                history.push(paths.client.offers.create);
              }}
              btnName="Create Offer"
              customClasses="shadow-md font-medium border py-1 px-6 !border-themeBorder"
              iconPosition="left"
            >
              <MdOutlineFileUpload size={20} className="text-white font-bold" />
            </CustomButton>
          ) : (
            <div className="mb-20" />
          )}
        </div>
      </div>
      <div className="jobCreationListing   mt-6 bg-white px-14 py-4 rounded-lg">
        <SearchBox
          placeholder="Type to search..."
          value={searchInput}
          onChange={value => setSearchInput(value)}
        />

        <CustomTabs currentTab={currentTab} onTabChange={setCurrentTab}>
          <div tabKey="1">
            <Row>
              <Table
                isLoading={isLoading}
                data={offers}
                columns={columns}
                scroll={1300}
                pagination={false}
                count={pagination?.count}
                onChangePage={setPage}
                page={page}
                onPageSizeChange={setPageSize}
              />
            </Row>
            <div className="flex justify-center border-t mt-10 pt-4">
              <Pagination
                onChange={setPage}
                current={page}
                defaultCurrent={1}
                total={pagination?.count}
                showSizeChanger
                onShowSizeChange={handlePageSizeChange}
                pageSizeOptions={["10", "20", "50", "100"]}
              />
            </div>
          </div>
          <div tabKey="2">
            <Row>
              <Table
                isLoading={isLoading}
                data={offers}
                columns={columns}
                scroll={1300}
                pagination={false}
                count={pagination?.count}
                onChangePage={setPage}
                page={page}
                onPageSizeChange={setPageSize}
              />
            </Row>
            <div className="flex justify-center border-t mt-10 pt-4">
              <Pagination
                onChange={setPage}
                current={page}
                defaultCurrent={1}
                total={pagination?.count}
                showSizeChanger
                onShowSizeChange={handlePageSizeChange}
                pageSizeOptions={["10", "20", "50", "100"]}
              />
            </div>
          </div>
          <div tabKey="3">
            <Row>
              <Table
                isLoading={isLoading}
                data={offers}
                columns={columns}
                scroll={1300}
                pagination={false}
                count={pagination?.count}
                onChangePage={setPage}
                page={page}
                onPageSizeChange={setPageSize}
              />
            </Row>
            <div className="flex justify-center border-t mt-10 pt-4">
              <Pagination
                onChange={setPage}
                current={page}
                defaultCurrent={1}
                total={pagination?.count}
                showSizeChanger
                onShowSizeChange={handlePageSizeChange}
                pageSizeOptions={["10", "20", "50", "100"]}
              />
            </div>
          </div>
        </CustomTabs>
      </div>
      <EditDialog
        visible={open}
        handleCancel={handleCancel}
        handleOk={() => {
          if (selectedOffer) {
            handleEditClick(selectedOffer.id, selectedOffer.stage);
          }
        }}
        loading={isLoadingReviseOffer}
      />
    </div>
  );
};

export default Offers;
